import _ from 'lodash';
import moment from 'moment';

import * as types from '../actions/types';
import { getScheduleGroups } from '../utils/getScheduleGroups';

moment.locale('ru');

const initialState = {
  scheduleOnDate: [],
  teacherSchedule: null,
  date: moment().format('YYYY-MM-DD'),
  schedule: {},
  groups: {},
  educationYear: [],
  edyId: 1,
  isLoading: false,
  groupsSchedule: []
};

export default function schedule(state = initialState, action) {
  switch (action.type) {
    case types.SCHEDULE_ON_DATE_FETCH_STARTED:
      return {
        ...state,
        isLoading: true,
      };
    case types.SCHEDULE_ON_DATE_FETCH_COMPLETED:
      return {
        ...state,
        isLoading: false,
        scheduleOnDate: action.schedule,
      };
    case types.SCHEDULE_FETCH_STARTED:
      return {
        ...state,
        isLoading: true,
      };
    case types.SCHEDULE_FETCH_COMPLETED: {
      const groups = getScheduleGroups(action.schedule)
      return {
        ...state,
        isLoading: false,
        schedule: action.schedule,
        edyId: action.edyId,
        groups,
      };
    }
    case types.EDUCATION_YEAR_FETCH_COMPLETED: {
      return {
        ...state,
        educationYear: action.educationYear,
      };
    }
    case types.EDUCATION_YEAR_FETCHED: {
      // const allYears = { name: 'Все', syid: 0 };
      // const studyYear = [allYears, ...action.studyYear];
      // return {
      //   ...state,
      //   studyYear,
      // };

      return {
        ...state,
        studyYear: action.studyYear,
      };
    }
    case types.SPECIALTY_FETCHED: {
      const allSpecialty = { name: 'Все', mpid: 0 };
      const specialty = [allSpecialty, ...action.militaryProfession];
      return {
        ...state,
        specialty,
      };
    }
    case types.CURRICULUM_FETCHED: {
      return {
        ...state,
        curriculum: action.curriculum,
      };
    }
    case types.PLAN_FETCH_STARTED: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case types.PLAN_FETCH_COMPLETED: {
      return {
        ...state,
        plan: action.plan[0],
        isLoading: false,
      };
    }
    case types.SET_TEACHER_SCHEDULE: {
      return {
        ...state,
        teacherSchedule: action.payload,
      };
    }
    case types.SET_GROUPS_SCHEDULE: {
      return {
        ...state,
        groupsSchedule: action.payload,
      };
    }
    case types.SCHEDULE_FETCH_FAILED: {
      return {
        ...state,
        isLoading: false,
      };
    }
    default:
      return state;
  }
}
